import { render, staticRenderFns } from "./FooterCadastro.vue?vue&type=template&id=0ac7bb06&"
import script from "./FooterCadastro.vue?vue&type=script&lang=js&"
export * from "./FooterCadastro.vue?vue&type=script&lang=js&"
import style0 from "./FooterCadastro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports